import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error file not migrated yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { ArtificialIntelligenceIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const AUTO_ASSOCIATIONS_KB_URL = 'https://knowledge.hubspot.com/calling/manage-phone-numbers-registered-for-calling#turn-on-conversation-intelligence-sales-hub-or-service-hub-professional-or-enterprise-only';
const ArtificialIntelligenceAssociationIcon = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardAssociatedObjects.ArtificialIntelligenceAssociationIcon.tooltip_jsx",
      elements: {
        KnowledgeBaseButton
      },
      options: {
        url: AUTO_ASSOCIATIONS_KB_URL
      }
    }),
    children: /*#__PURE__*/_jsx(IconHolder, {
      icon: ArtificialIntelligenceIcon,
      color: "icon-core-subtle"
    })
  });
};
export default ArtificialIntelligenceAssociationIcon;